/* eslint-disable react/require-default-props */
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';

import {Shared} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './RadioButton.style';

interface RadioButtonProps {
  text: string;
  selected: boolean;
  onPress: () => void;
  testID?: string;
  isBold: boolean;
  accessibilityLabel?: string;
  accessibilityHint?: string;
  allowFontScaling?: boolean;
  maxFontSizeMultiplier?: number;
}

const DEFAULT_MAX_FONT_SIZE_MULTIPLIER = 2;

const RadioButton: React.FC<RadioButtonProps> = ({
  text = '',
  selected = false,
  onPress,
  testID = '',
  isBold = false,
  accessibilityLabel = '',
  accessibilityHint = '',
  allowFontScaling = true,
  maxFontSizeMultiplier = DEFAULT_MAX_FONT_SIZE_MULTIPLIER,
}) => {
  const stateSuffix = selected ? 'selected' : 'not-selected';

  return (
    <TouchableOpacity
      style={styles.radioButtonContainer}
      {...testProperties(`${testID || Shared.radioButtonGroup}-${stateSuffix}`)}
      testID={testID}
      accessible={true}
      accessibilityRole="radio"
      accessibilityState={{selected}}
      accessibilityLabel={accessibilityLabel || text}
      accessibilityHint={accessibilityHint}
      onPress={onPress}>
      <View
        style={selected ? styles.radioButtonSelected : styles.radioButton}
        {...testProperties(
          `icon-${testID || Shared.radioButton}-${stateSuffix}`,
          true,
        )}
      />

      <Text
        accessible={false}
        allowFontScaling={allowFontScaling}
        maxFontSizeMultiplier={maxFontSizeMultiplier}
        style={
          text === 'Do Not Contact' || selected || isBold
            ? styles.radioButtonTextSelected
            : styles.radioButtonText
        }
        {...testProperties(
          `${testID || Shared.radioButtonLabel}-${stateSuffix}`,
        )}>
        {text}
      </Text>
    </TouchableOpacity>
  );
};

export default RadioButton;
